import React, { Suspense } from "react";
import DesktopNavBar from "./desktop";
import MobileNavBar from "./mobile";
import MobileNavBarLists from "./mobileLists";
import {
	Breakpoint,
	DropShadowWeight,
	FontWeight,
	IBottomItem,
	INavBarColors,
	ITopItem,
	ItemsGap,
	TextSize,
} from "./types";

export interface INavBarProps {
	readonly topItems?: ReadonlyArray<ITopItem>;
	readonly bottomItems?: ReadonlyArray<IBottomItem>;
	readonly siteIdentityImageUrl: string;
	readonly siteIdentityLinkTooltip: string;
	readonly colors?: INavBarColors;
	readonly textSize?: TextSize;
	readonly mobileBreakpoint?: Breakpoint;
	readonly bottomBarItemsGap?: ItemsGap;
	readonly itemsFontWeight?: FontWeight;
	readonly belowBarDropShadowWeight?: DropShadowWeight;
	readonly transparentUntilScroll?: boolean;
	readonly absolute?: boolean;
	readonly bottomBarHoverUnderline?: boolean;
}
const NavBar: React.FC<INavBarProps> = ({
	topItems,
	bottomItems,
	siteIdentityImageUrl,
	siteIdentityLinkTooltip,
	colors,
	textSize = TextSize.Large,
	mobileBreakpoint = Breakpoint.lg,
	bottomBarItemsGap = ItemsGap.Large,
	itemsFontWeight = FontWeight.ExtraBold,
	belowBarDropShadowWeight = DropShadowWeight.Light,
	transparentUntilScroll,
	absolute = false,
	bottomBarHoverUnderline = true,
}) => {
	const accentColorStyles = {
		"--epic-nav-top-bar-background-color": colors?.topBarBackground || "#FFFFFF",
		"--epic-nav-hover-logo-back-color": colors?.hoverLogoBackground || "#EAE5E1",
		"--epic-nav-logo-fill-color": colors?.logoFill || "#6B615C",
		"--epic-nav-text-color": colors?.text || "#3D2C2B",
		"--epic-nav-bottom-bar-submenu-background-color":
			colors?.bottomBarSubmenuBackground || "#FFFFFF",
		"--epic-nav-bottom-bar-submenu-item-text-color": colors?.bottomBarSubmenuItemText || "#6B615C",
		"--epic-nav-bottom-bar-back-color": colors?.bottomBarBackground || "#EAE5E1",
		"--epic-nav-submenu-border-color": colors?.submenuBorder || "#EAE5E1",
		"--epic-nav-submenu-background-color": colors?.submenuBackground || "#EAE5E1",
		"--epic-nav-hover-logo-fill-color": colors?.hoverLogoFill || "#CD1543",
		"--epic-nav-hover-text-color": colors?.hoverText || "#CD1543",
		"--epic-nav-selected-logo-back-color": colors?.selectedLogoBackground || "#CD1543",
		"--epic-nav-selected-hover-logo-back-color": colors?.selectedHoverLogoBackground || "#CD1543",
		"--epic-nav-selected-logo-fill-color": colors?.selectedLogoFill || "#FFFFFF",
		"--epic-nav-selected-hover-logo-fill-color": colors?.selectedHoverLogoFill || "#FFFFFF",
		"--epic-nav-mobile-navigation-button-color": colors?.mobileNavigationButton || "#6B7280",
		"--epic-nav-mobile-navigation-pane-border-color":
			colors?.mobileNavigationPaneBorder || "#334155",
		"--epic-nav-standalone-epic-logo-back-color": colors?.standaloneEpicLogoBackground || "#D31E47",
		"--epic-nav-bottom-bar-button-background-color": colors?.bottomBarButtonBackground || "#CD1543",
		"--epic-nav-bottom-bar-button-hover-background-color":
			colors?.bottomBarButtonHoverBackground || "#CD1543",
		"--epic-nav-bottom-bar-button-focus-background-color":
			colors?.bottomBarButtonFocusBackground || "#CD1543",
		"--epic-nav-bottom-bar-button-text-color": colors?.bottomBarButtonText || "#FFFFFF",
		"--epic-nav-chevron-fill-color": colors?.chevronFill || "#6B615C",
		"--epic-nav-chevron-hover-fill-color": colors?.chevronHoverFill || "#CD1543",
		"--epic-nav-selected-bottom-bar-underline-back-color":
			colors?.selectedBottomBarUnderlineBackground || "transparent",
		"--epic-nav-selected-bottom-bar-item-back-color":
			colors?.selectedBottomBarItemBackground || "#CD1543",
		"--epic-nav-selected-bottom-bar-item-hover-back-color":
			colors?.selectedBottomBarItemHoverBackground || "#CD1543",
		"--epic-nav-selected-hover-text-color": colors?.selectedHoverText || "#FFFFFF",
	} as React.CSSProperties;
	return (
		<div className={absolute ? "epic-header-absolute" : ""} style={accentColorStyles}>
			<Suspense fallback={<div></div>}>
				<MobileNavBar
					siteIdentityImageUrl={siteIdentityImageUrl}
					siteIdentityLinkTooltip={siteIdentityLinkTooltip}
					mobileBreakpoint={mobileBreakpoint}
					itemsFontWeight={itemsFontWeight}
					transparentUntilScroll={transparentUntilScroll}
				>
					<MobileNavBarLists
						topItems={topItems}
						bottomItems={bottomItems}
						bottomBarHoverUnderline={bottomBarHoverUnderline}
					/>
				</MobileNavBar>
				<DesktopNavBar
					topItems={topItems}
					bottomItems={bottomItems}
					siteIdentityImageUrl={siteIdentityImageUrl}
					siteIdentityLinkTooltip={siteIdentityLinkTooltip}
					textSize={textSize}
					mobileBreakpoint={mobileBreakpoint}
					bottomBarItemsGap={bottomBarItemsGap}
					itemsFontWeight={itemsFontWeight}
					belowBarDropShadowWeight={belowBarDropShadowWeight}
					transparentUntilScroll={transparentUntilScroll}
					bottomBarHoverUnderline={bottomBarHoverUnderline}
				/>
			</Suspense>
		</div>
	);
};
export default NavBar;

